<template>
  <div class="menu">
    <div class="menu__container">
      <div
        class="menu__item"
        :class="{activeItem: isActive(item.link)}"
        v-for="item in menuList"
        :key="item.name"
        @click="()=>goToSites(item.link)"
      >
        {{ item.name }}
      </div>
    </div>
  </div>
</template>

<script>
import mixin from '../mixin';

export default {
  mixins: [mixin]
}
</script>

<style scoped lang="scss">
  .menu {
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    max-width: 1200px;
    margin: 0 auto;
    display: flex;
    position: fixed;
    box-sizing: border-box;
    flex-direction: column;
    z-index: 20;
    background-image: url('~@/assets/menuMobile__background.png');
    background-size: contain;
    background-repeat: no-repeat;
    background-color: #191e2a;
    &__item {
      font-family: 'Poppins', sans-serif;
          font-size: 1.6rem;
      color: #d0d0e0;
      text-transform: uppercase;
      cursor: pointer;
      text-shadow: 1px 1px #000;
    padding: 1rem 0 1rem 10%;
    margin-top: 2.5rem}
    &__item:hover {
      background-color: #df2860;
      border-radius: 5px;
      color: #fefefe;
    }
    .activeItem {
      background-image: url('~@/assets/menuMobile__active.png');
      background-size: cover;
      border-radius: 5px;
      color: #fefefe;
    }
    &__container {
      height: 100%;
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      margin-top: 10rem;
      padding-bottom: 3rem;
    }
  }
</style>
